<template>
  <div type="flex" class="vedeo-container">
    <div class="list-wrap scroll-container">
      <!-- <div class="m-b-8">
                <a @click.stop="backVedio" style="color:#40a9ff"
                    ><a-icon type="arrow-left" /> 返回</a
                >
      </div>-->
      <BaseContentBox title="监控列表">
        <div class="cameraList">
          <li @click="selectChannel(item, key)" v-for="(item, key) in cameraList" :key="key">
            <a>{{ item.channelName }}</a>
          </li>
        </div>
        <!-- <div style="text-align: center">
          <a-input-search
            class="sskClass"
            placeholder="搜索名称"
            style="width: 200px"
            @search="onSearch"
          />
        </div>
        <a-menu
          :default-selected-keys="['1']"
          mode="inline"
          :open-keys="openKeys"
          style="width: 210px"
          @openChange="onOpenChange"
        >
          <a-menu-item key="1">
            <span>监控列表</span>
          </a-menu-item>
        </a-menu>-->
      </BaseContentBox>
    </div>
    <div class="body-container">
      <BaseContentBox title="视频监控" :width="300" :showBackButon="true">
        <!-- <monitor :monitoringNumber="'123'"></monitor> -->
        <!-- 分屏设置 -->
        <div class="top-splitscreen">
          <a-select
            class="top-splitscreen-select"
            placeholder="分屏设置"
            :value="splitScreen"
            @change="
              (value) => {
                splitScreenChange(value, splitScreen);
              }
            "
          >
            <a-icon slot="suffixIcon" type="caret-down" />
            <a-select-option
              v-for="item in enumSplitScreenSet"
              :key="item.value"
              :value="item.value"
            >{{ item.label }}</a-select-option>
          </a-select>
        </div>

        <!--ezopen:// [设备验证码@] open.ys7.com/[deviceSerial]/[channelNo] [.hd].live
        设备验证码:BDZYWK
        设备序列号：F43457002 
        channelNo:12
        token：741a1f70-8688-421d-97c7-d5a1d0344fe8-->
        <!-- <iframe
          v-if="iframeurl"
          :src="iframeurl"
          width="560"
          height="450"
          id="ysOpenDevice"
          allowfullscreen
        ></iframe>-->

        <div class="monitor-content">
          <div class="content-bottom">
            <div class="monitor-column" v-for="column in splitScreen" :key="column">
              <div
                class="monitor-row"
                v-for="row in splitScreen"
                :key="row"
                :class="{
                  active: (column - 1) * splitScreen + row - 1 == selectScreen,
                }"
                :ref="`video_${(column - 1) * splitScreen + row - 1}`"
              >
                <iframe
                  v-if="dataScreen[(column - 1) * splitScreen + row - 1]"
                  class="videp-player"
                  :src="dataScreen[(column - 1) * splitScreen + row - 1]"
                ></iframe>
                <div
                  class="iframe-mask"
                  @click="
                    () => {
                      selectScreen = (column - 1) * splitScreen + row - 1;
                    }
                  "
                >
                  <template v-if="dataScreen[(column - 1) * splitScreen + row - 1]">
                    <a-button
                      v-if="
                        fullScreenElement !=
                        $refs[
                          'video_' + ((column - 1) * splitScreen + row - 1)
                        ][0]
                      "
                      class="iframe-close"
                      size="small"
                      @click.stop="
                        closeVideo((column - 1) * splitScreen + row - 1)
                      "
                    >关闭</a-button>
                    <div class="iframe-note">
                      <label
                        class="note-name"
                      >{{ nameScreen[(column - 1) * splitScreen + row - 1] }}</label>
                      <i
                        :class="`ali-icon ali-icon-action-${
                          fullScreenElement ==
                          $refs[
                            'video_' + ((column - 1) * splitScreen + row - 1)
                          ][0]
                            ? 'exitscreen'
                            : 'fullscreen'
                        }`"
                        @click.stop="
                          screenVideo((column - 1) * splitScreen + row - 1)
                        "
                      ></i>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BaseContentBox>
    </div>
    <!-- :mask="false" -->
    <a-drawer
      title="云台控制"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      width="300"
      :maskStyle="{ background: 'rgba(0,0,0,0)' }"
    >
      <div @click="onClose" class="guanbi">
        <a-icon style="color: white" type="close" />
      </div>
      <div class="video-control">
        <!-- 按钮控制 -->
        <div class="control-c">
          <div class="box">
            <div>
              <img
                @click="PtzFocusDowns(11)"
                class="nearFocus"
                src="@/assets/image/shipin/FocusDown_d.png"
                alt
              />
            </div>
            <div class="text-center">
              <span>变焦</span>
            </div>

            <div class="text-right">
              <img
                src="@/assets/image/shipin/FocusUp_d.png"
                class="farFocus"
                @click="PtzFocusDowns(10)"
                alt
              />
            </div>
          </div>
          <div class="box">
            <div>
              <img
                src="@/assets/image/shipin/scaleMinus_d.png"
                class="narrow"
                @click="PtzFocusDowns(9)"
                alt
              />
            </div>
            <div class="text-center">
              <span>变倍</span>
            </div>

            <div class="text-right">
              <img
                src="@/assets/image/shipin/scaleAdd_d.png"
                class="enlarge"
                @click="PtzFocusDowns(8)"
                alt
              />
            </div>
          </div>
          <div class="box">
            <div>
              <img
                src="@/assets/image/shipin/ApertureDown_d.png"
                class="stopDown"
                @click="PtzFocusDowns(12)"
                alt
              />
            </div>

            <div class="text-center">
              <span>光圈</span>
            </div>
            <div class="text-right">
              <img
                src="@/assets/image/shipin/ApertureUp_d.png"
                class="stopUp"
                @click="PtzFocusDowns(13)"
                alt
              />
            </div>
          </div>
        </div>
        <!-- 滑块控制 -->
        <div class="control-d">
          <div>
            <div class="contrl_back">
              <img src="@/assets/image/shipin/control_back.png" alt />
            </div>
            <img
              src="@/assets/image/shipin/up_disabled.png"
              @mousedown="PtzDirection(0)"
              @mouseup="PtzDirectionStop(0)"
              class="up"
              alt
            />
            <img
              src="@/assets/image/shipin/down_disabled.png"
              @mousedown="PtzDirection(1)"
              @mouseup="PtzDirectionStop(1)"
              class="down"
              alt
            />
            <img
              src="@/assets/image/shipin/left_disabled.png"
              @mousedown="PtzDirection(2)"
              @mouseup="PtzDirectionStop(2)"
              class="left"
              alt
            />
            <img
              src="@/assets/image/shipin/right_disabled.png"
              @mousedown="PtzDirection(3)"
              @mouseup="PtzDirectionStop(3)"
              class="right"
              alt
            />
          </div>
        </div>
        <!-- 按钮块控制 -->
        <div class="control-p">
          <div class="box">
            <div>
              <li @click="play()">
                <img src="@/assets/image/shipin/icon_splj.png" alt />
                <p>播放</p>
              </li>
            </div>
            <div>
              <li @click="stopPlay()">
                <img src="@/assets/image/shipin/icon_pause.png" alt />
                <p>停止</p>
              </li>
            </div>
          </div>
          <div class="box">
            <div>
              <li @click="CapturePicture()">
                <img src="@/assets/image/shipin/icon_jt.png" alt />
                <p>抓图</p>
              </li>
            </div>
            <div>
              <li id="record">
                <img state="false" src="@/assets/image/shipin/icon_lx.png" alt />
                <p>录像</p>
                <!-- <img
                  src="@/assets/image/shipin/play.gif"
                  alt=""
                  id="recordActive"
                />-->
              </li>
            </div>
          </div>
          <div style="text-align: center; margin: 20px 0; color: #ffffff">
            <p>码流</p>
          </div>
          <div class="box stream-type" id="streamType">
            <div class="item" @click="changeType(0)">
              <li type="1" :class="typeStatus == 0 ? 'control_active' : ''">
                <span>主码流</span>
              </li>
            </div>
            <div class="item" @click="changeType(1)">
              <li class :class="typeStatus == 0 ? '' : 'control_active'" type="2">
                <span>辅码流</span>
              </li>
            </div>
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script src="<%= BASE_URL %>jquery-1.7.1.min.js"></script>
    <script src="<%= BASE_URL %>webVideoCtrl.js"></script>
<script>
// import $ from "jquery";
import BaseContentBox from "@/components/BaseContentBox";

// import monitor from "./components/Monitor";//海康摄像头

// import {WebVideoCtrl} from './js/webVideoCtrl.js'

import { enumSplitScreenSet } from "@/utils/EnumUtils";
export default {
  components: { BaseContentBox },
  data() {
    return {
      ocx: {},
      cameraList: [
        {
          deviceSerial: 'G74688350',
          channelNo: '1',
          channelName: '车辆进出通道'
        },
        {
          deviceSerial: 'G74688350',
          channelNo: '2',
          channelName: '工地工人通道'
        },
        {
          deviceSerial: 'G74688350',
          channelNo: '3',
          channelName: '人员门禁通道'
        }
      ],
      //   cameraList: [
      //     {
      //       deviceSerial: 'G74688350',
      //       channelNo: '646ae9d7690c48078ed4deeaa9dbeef3',
      //       channelName: '车辆进出通道'
      //     },
      //     {
      //       deviceSerial: 'G74688350',
      //       channelNo: '98e8c5f7cb66462d8bff8acb89aea762',
      //       channelName: '工地工人通道'
      //     },
      //     {
      //       deviceSerial: 'G74688350',
      //       channelNo: 'a3dfcf8f364549d4ae4f72bb76d4b501',
      //       channelName: '人员门禁通道'
      //     }
      //   ],
      iframeurl: "",
      accessToken: "",
      index: 0,
      splitScreen: 3,
      dataScreen: ["", "", "", "", "", "", "", "", ""],
      nameScreen: ["", "", "", "", "", "", "", "", ""],
      selectScreen: 0,
      enumSplitScreenSet: enumSplitScreenSet,
      rootSubmenuKeys: ["sub1", "sub2", "sub4"],
      openKeys: ["sub1"],
      fullScreenElement: null,
      visible: false,
      deviceSerial: "F41024050",
      typeStatus: 0,
    };
  },
  created() {
    this.loginCamera();
    // this.queryCameraList();
    // this.getDetail();
    // this.init();
  },
  mounted() {
    if (document.documentElement.onfullscreenchange) {
      window.addEventListener("fullscreenchange", this.fullScreenChange);
    } else if (document.documentElement.onwebkitfullscreenchange) {
      window.addEventListener("webkitfullscreenchange", this.fullScreenChange);
    } else if (document.documentElement.onmozfullscreenchange) {
      window.addEventListener("mozfullscreenchange", this.fullScreenChange);
    } else if (document.documentElement.onmsfullscreenchange) {
      window.addEventListener("msfullscreenchange", this.fullScreenChange);
    }
  },
  destroyed() {
    if (document.documentElement.onfullscreenchange) {
      window.removeEventListener("fullscreenchange", this.fullScreenChange);
    } else if (document.documentElement.onwebkitfullscreenchange) {
      window.removeEventListener(
        "webkitfullscreenchange",
        this.fullScreenChange
      );
    } else if (document.documentElement.onmozfullscreenchange) {
      window.removeEventListener("mozfullscreenchange", this.fullScreenChange);
    } else if (document.documentElement.onmsfullscreenchange) {
      window.removeEventListener("msfullscreenchange", this.fullScreenChange);
    }
  },
  methods: {
    loginCamera() {
      this.$api.loginCamera().then(res => {
        console.log('res', res);
        if (res.code == 200) {
          this.accessToken = res.data.token;
          console.log('accessToken', this.accessToken);
        }
      })
    },
    queryCameraList() {
      let params = {
        storeId: "d43786b9fe2f4460a6bc0f7fc0320edd",
        pageNo: 1,
        pageSize: 30,
      };
      this.$api.queryCameraLists(params).then((res) => {
        if (res.code === 200) {
          this.cameraList = res.data.rows;
          this.$api.queryCameraAccountInfo().then((res) => {
            if (res.code === 200) {
              this.accessToken = res.data.token;
              this.iframeurl =
                "https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://BDZYWK@open.ys7.com/" +
                this.cameraList[this.index].deviceSerial +
                "/" +
                this.cameraList[this.index].channelNo +
                ".live" +
                "&accessToken=" +
                res.data.token;
              console.log("88888>", this.iframeurl);
            }
          });
        }
      });
    },
    btnClick(data) {
      console.log(data);
      if (data) {
        this.visible = true;
      }
    },
    onSearch() { },
    selectChannel(item, index) {
      console.log(item);
      this.index = index;
      //   this.iframeurl =
      //     "https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://BDZYWK@open.ys7.com/" +
      //     this.cameraList[this.index].deviceSerial +
      //     "/" +
      //     this.cameraList[this.index].channelNo +
      //     ".live" +
      //     "&accessToken=" +
      //     this.accessToken;
      console.log(`/work-site/ezuikit_v3.4/index.html?audio=0&accessToken=${this.accessToken
        }&hd=1&deviceSerial=${this.cameraList[this.index].deviceSerial}&channelNo=${parseInt(
          this.cameraList[this.index].channelNo
        )}`);
      this.dataScreen[
        this.selectScreen
      ] = `/work-site/ezuikit_v3.4/index.html?audio=0&accessToken=${this.accessToken
      }&hd=1&deviceSerial=${this.cameraList[this.index].deviceSerial}&channelNo=${parseInt(
        this.cameraList[this.index].channelNo
      )}`
      //   this.dataScreen[
      //     this.selectScreen
      //   ] = `https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://BDZYWK@open.ys7.com/${this.cameraList[this.index].deviceSerial}/${parseInt(
      //     this.cameraList[this.index].channelNo)}.live&accessToken=${this.accessToken}`
      this.nameScreen[this.selectScreen] = this.cameraList[this.index].channelName;
      let newSelect = 0
      if (this.selectScreen < this.dataScreen.length - 1) {
        newSelect = this.selectScreen + 1
      }
      this.selectScreen = -1
      this.$nextTick(() => {
        this.selectScreen = newSelect
        // this.saveUserHabit()
      })
    },
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    onClose() {
      this.visible = false;
    },
    isIE() {
      // if (!!window.ActiveXObject || "ActiveXObject" in window) {
      //     return true
      // } else {
      //     return false
      // }
    },
    backVedio() {
      this.$emit("hideVedio");
    },
    init() {
      let that = this;
      // 初始化插件
      // let version = "websdk3.220200615";
      console.log("执行", WebVideoCtrl);
      // 全局保存当前选中窗口
      let g_iWndIndex = 0; //可以不用设置这个变量，有窗口参数的接口中，不用传值，开发包会默认使用当前选择窗口
      $(function () {
        // 检查插件是否已经安装过
        var iRet = window.WebVideoCtrl.I_CheckPluginInstall();
        if (-1 == iRet) {
          alert(
            "您还未安装过插件，双击开发包目录里的WebComponentsKit.exe安装！"
          );
          return;
        }

        // 初始化插件参数及插入插件
        WebVideoCtrl.I_InitPlugin("100%", "100%", {
          bWndFull: true, //是否支持单窗口双击全屏，默认支持 true:支持 false:不支持
          iPackageType: 2,
          //szColorProperty:"plugin-background:0000ff; sub-background:0000ff; sub-border:00ffff; sub-border-select:0000ff",   //2:PS 11:MP4
          iWndowType: 1,
          // proxyAddress:{
          //    port:"80",  //摄像头端口
          //    ip:"10.18.99.194",//摄像头ip
          //    wsport:"7681"//摄像头ws端口
          //},
          bNoPlugin: true,
          cbSelWnd: function (xmlDoc) {
            g_iWndIndex = parseInt(
              $(xmlDoc).find("SelectWnd").eq(0).text(),
              10
            );
            var szInfo = "当前选择的窗口编号：" + g_iWndIndex;
            showCBInfo(szInfo);
          },
          cbDoubleClickWnd: function (iWndIndex, bFullScreen) {
            var szInfo = "当前放大的窗口编号：" + iWndIndex;
            if (!bFullScreen) {
              szInfo = "当前还原的窗口编号：" + iWndIndex;
            }
            showCBInfo(szInfo);
          },
          cbEvent: function (iEventType, iParam1, iParam2) {
            if (2 == iEventType) {
              // 回放正常结束
              showCBInfo("窗口" + iParam1 + "回放结束！");
            } else if (-1 == iEventType) {
              showCBInfo("设备" + iParam1 + "网络错误！");
            } else if (3001 == iEventType) {
              clickStopRecord(g_szRecordType, iParam1);
            }
          },
          cbRemoteConfig: function () {
            showCBInfo("关闭远程配置库！");
          },
          cbInitPluginComplete: function () {
            WebVideoCtrl.I_InsertOBJECTPlugin("divPlugin");

            // 检查插件是否最新
            if (-1 == WebVideoCtrl.I_CheckPluginVersion()) {
              alert(
                "检测到新的插件版本，双击开发包目录里的WebComponentsKit.exe升级！"
              );
              return;
            }
          },
        });

        // 窗口事件绑定
        $(window).bind({
          resize: function () {
            //WebVideoCtrl.I_Resize($("body").width(), $("body").height());
          },
        });

        //初始化日期时间
        var szCurTime = that.dateFormat(new Date(), "yyyy-MM-dd");
        $("#starttime").val(szCurTime + " 00:00:00");
        $("#endtime").val(szCurTime + " 23:59:59");
        $("#downloadstarttime").val(szCurTime + " 00:00:00");
        $("#downloadendtime").val(szCurTime + " 23:59:59");
        if (WebVideoCtrl.I_SupportNoPlugin()) {
          $(".localconfig").hide();
          $(".ipparse").hide();
          $("#checkVersion").hide();
          $("#remoteconfig").hide();
          $("#btnReverse").hide();
          $("#btnReverse").show();
        } else {
          $("#fullbtn").hide();
        }
      });
      console.log("初始化完成");
      this.clickLogin();
    },
    // 登录函数
    clickLogin() {
      let that = this;
      console.log("登录开始");
      var szIP = "/videoagent",
        szPort = "80",
        szUsername = "admin",
        szPassword = "hyxk123!@#";

      if ("" == szIP || "" == szPort) {
        return;
      }

      var szDeviceIdentify = szIP + "_" + szPort;

      var iRet = WebVideoCtrl.I_Login(szIP, 1, szPort, szUsername, szPassword, {
        success: function (xmlDoc) {
          console.log("登录成功！");
          // showOPInfo(szDeviceIdentify + " 登录成功！");
          $("#ip").prepend(
            "<option value='" +
            szDeviceIdentify +
            "'>" +
            szDeviceIdentify +
            "</option>"
          );
          setTimeout(function () {
            $("#ip").val(szDeviceIdentify);
            this.getChannelInfo();
            this.getDevicePort();
          }, 10);
        },
        error: function (status, xmlDoc) {
          console.log("登录失败！");
          that.getChannelInfo();
          that.getDevicePort();
          // showOPInfo(szDeviceIdentify + " 登录失败！", status, xmlDoc);
        },
      });
      if (-1 == iRet) {
        console.log("已登录过！");
        // showOPInfo(szDeviceIdentify + " 已登录过！");
      }
    },
    // 获取通道
    getChannelInfo() {
      var szDeviceIdentify = $("#ip").val(), //获取已经登录的设备
        oSel = $("#channels").empty();
      if (null == szDeviceIdentify) {
        console.log("返回");
        return;
      }

      // 模拟通道
      WebVideoCtrl.I_GetAnalogChannelInfo(szDeviceIdentify, {
        async: false,
        success: function (xmlDoc) {
          var oChannels = $(xmlDoc).find("VideoInputChannel");

          $.each(oChannels, function (i) {
            var id = $(this).find("id").eq(0).text(),
              name = $(this).find("name").eq(0).text();
            if ("" == name) {
              name = "Camera " + (i < 9 ? "0" + (i + 1) : i + 1);
            }
            oSel.append(
              "<option value='" + id + "' bZero='false'>" + name + "</option>"
            );
          });
          console.log("获取模拟通道成功！");
          // showOPInfo(szDeviceIdentify + " 获取模拟通道成功！");
        },
        error: function (status, xmlDoc) {
          console.log("获取模拟通道失败！");
          // showOPInfo(szDeviceIdentify + " 获取模拟通道失败！", status, xmlDoc);
        },
      });
      // 数字通道
      WebVideoCtrl.I_GetDigitalChannelInfo(szDeviceIdentify, {
        async: false,
        success: function (xmlDoc) {
          var oChannels = $(xmlDoc).find("InputProxyChannelStatus");

          $.each(oChannels, function (i) {
            var id = $(this).find("id").eq(0).text(),
              name = $(this).find("name").eq(0).text(),
              online = $(this).find("online").eq(0).text();
            if ("false" == online) {
              // 过滤禁用的数字通道
              return true;
            }
            if ("" == name) {
              name = "IPCamera " + (i < 9 ? "0" + (i + 1) : i + 1);
            }
            oSel.append(
              "<option value='" + id + "' bZero='false'>" + name + "</option>"
            );
          });
          // showOPInfo(szDeviceIdentify + " 获取数字通道成功！");
          console.log("获取数字通道成功！");
        },
        error: function (status, xmlDoc) {
          console.log("获取数字通道失败！");
          // showOPInfo(szDeviceIdentify + " 获取数字通道失败！", status, xmlDoc);
        },
      });
      // 零通道
      WebVideoCtrl.I_GetZeroChannelInfo(szDeviceIdentify, {
        async: false,
        success: function (xmlDoc) {
          var oChannels = $(xmlDoc).find("ZeroVideoChannel");

          $.each(oChannels, function (i) {
            var id = $(this).find("id").eq(0).text(),
              name = $(this).find("name").eq(0).text();
            if ("" == name) {
              name = "Zero Channel " + (i < 9 ? "0" + (i + 1) : i + 1);
            }
            if ("true" == $(this).find("enabled").eq(0).text()) {
              // 过滤禁用的零通道
              oSel.append(
                "<option value='" + id + "' bZero='true'>" + name + "</option>"
              );
            }
          });
          // showOPInfo(szDeviceIdentify + " 获取零通道成功！");
          console.log("获取零通道成功！");
        },
        error: function (status, xmlDoc) {
          console.log("获取零通道失败！");
          // showOPInfo(szDeviceIdentify + " 获取零通道失败！", status, xmlDoc);
        },
      });
    },
    // 获取端口
    getDevicePort() {
      var szDeviceIdentify = $("#ip").val();

      if (null == szDeviceIdentify) {
        return;
      }

      var oPort = WebVideoCtrl.I_GetDevicePort(szDeviceIdentify);
      if (oPort != null) {
        $("#deviceport").val(oPort.iDevicePort);
        $("#rtspport").val(oPort.iRtspPort);
        console.log("获取端口成功！");
        // showOPInfo(szDeviceIdentify + " 获取端口成功！");
      } else {
        console.log("获取端口失败！");
        // showOPInfo(szDeviceIdentify + " 获取端口失败！");
      }
    },
    // 停止预览
    clickStopRealPlay() {
      var oWndInfo = WebVideoCtrl.I_GetWindowStatus(g_iWndIndex),
        szInfo = "";

      if (oWndInfo != null) {
        WebVideoCtrl.I_Stop({
          success: function () {
            szInfo = "停止预览成功！";
            showOPInfo(oWndInfo.szDeviceIdentify + " " + szInfo);
          },
          error: function () {
            szInfo = "停止预览失败！";
            showOPInfo(oWndInfo.szDeviceIdentify + " " + szInfo);
          },
        });
      }
    },
    // 开始预览
    clickStartRealPlay(iStreamType) {
      var oWndInfo = WebVideoCtrl.I_GetWindowStatus(g_iWndIndex),
        szDeviceIdentify = $("#ip").val(),
        iRtspPort = parseInt($("#rtspport").val(), 10),
        iChannelID = parseInt($("#channels").val(), 10),
        bZeroChannel =
          $("#channels option")
            .eq($("#channels").get(0).selectedIndex)
            .attr("bZero") == "true"
            ? true
            : false,
        szInfo = "";

      if ("undefined" === typeof iStreamType) {
        iStreamType = parseInt($("#streamtype").val(), 10);
      }

      if (null == szDeviceIdentify) {
        return;
      }
      var startRealPlay = function () {
        WebVideoCtrl.I_StartRealPlay(szDeviceIdentify, {
          iRtspPort: iRtspPort,
          iStreamType: iStreamType,
          iChannelID: iChannelID,
          bZeroChannel: bZeroChannel,
          success: function () {
            szInfo = "开始预览成功！";
            showOPInfo(szDeviceIdentify + " " + szInfo);
          },
          error: function (status, xmlDoc) {
            if (403 === status) {
              szInfo = "设备不支持Websocket取流！";
            } else {
              szInfo = "开始预览失败！";
            }
            showOPInfo(szDeviceIdentify + " " + szInfo);
          },
        });
      };

      if (oWndInfo != null) {
        // 已经在播放了，先停止
        WebVideoCtrl.I_Stop({
          success: function () {
            startRealPlay();
          },
        });
      } else {
        startRealPlay();
      }
    },
    getDetail() {
      let params = {
        clientId: "a48f0c0fa7c8458ba1a1d900dce9062e",
        clientSecret: "c67d692a9fd24301973428e74f1a4450",
      };
      // http://183.62.163.43:9001/engineering-bigdata/ezuikit_v3.4/index.html?audio=0&accessToken=ra.bdxw84pwe0rcyznmdwgzfuvmc8fc3fng-7zp6gtk2r1-1w88acd-svmyjkk4p&hd=1&deviceSerial=F41024050&channelNo=1
      this.$api.oauthToken(params).then((response) => {
        console.log(response);
        if (response.code === 200) {
          this.accessToken = response.data.token;
          this.dataScreen[
            this.selectScreen
          ] = `/wisdom-building/ezuikit_v3.4/index.html?audio=0&accessToken=${response.data.token
          }&hd=1&deviceSerial=F41024050&channelNo=${parseInt(1)}`;
          console.log(this.dataScreen);
          this.nameScreen[this.selectScreen] = ""; //名称
          let newSelect = 0;
          if (this.selectScreen < this.dataScreen.length - 1) {
            newSelect = this.selectScreen + 1;
          }
          this.selectScreen = -1;
          this.$nextTick(() => {
            this.selectScreen = newSelect;
            // this.saveUserHabit();
          });
        }
      });
    },
    // 格式化时间
    dateFormat(oDate, fmt) {
      var o = {
        "M+": oDate.getMonth() + 1, //月份
        "d+": oDate.getDate(), //日
        "h+": oDate.getHours(), //小时
        "m+": oDate.getMinutes(), //分
        "s+": oDate.getSeconds(), //秒
        "q+": Math.floor((oDate.getMonth() + 3) / 3), //季度
        S: oDate.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (oDate.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    },






    saveUserHabit() {
      //   CommonApi.saveUserHabit({
      //     deployCode: "MonitorCenter",
      //     itemValue: JSON.stringify({
      //       splitScreen: this.splitScreen,
      //       dataScreen: this.dataScreen,
      //       selectScreen: this.selectScreen,
      //     }),
      //   });
    },
    splitScreenChange(nVal, oVal) {
      let arr = [...this.dataScreen];
      if (nVal > oVal) {
        for (let i = 0; i < nVal * nVal - oVal * oVal; i++) {
          arr.push("");
        }
      } else {
        for (let i = 0; i < oVal * oVal - nVal * nVal; i++) {
          arr.pop();
        }
      }
      this.splitScreen = nVal;
      this.dataScreen = arr;
      this.selectScreen = 0;
      //   this.saveUserHabit();
    },
    closeVideo(index) {
      this.dataScreen[index] = undefined;
      this.nameScreen[index] = "";
      let newSelect = 0;
      if (index < this.dataScreen.length) {
        newSelect = index;
      }
      this.selectScreen = -1;
      this.$nextTick(() => {
        this.selectScreen = newSelect;
        // this.saveUserHabit();
      });
    },
    screenVideo(index) {
      let domId = `video_${index}`;
      let ele = this.$refs[domId][0];
      let fullScreen = (
        ele.requestFullscreen ||
        ele.webkitRequestFullscreen ||
        ele.mozRequestFullScreen ||
        ele.msRequestFullscreen
      ).bind(ele);
      let exitFullScreen = (
        document.exitFullscreen ||
        document.webkitExitFullscreen ||
        document.mozCancelFullScreen ||
        document.msExitFullscreen
      ).bind(document);
      let eleFullScreen =
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement;
      if (eleFullScreen == ele) {
        exitFullScreen();
      } else {
        fullScreen();
      }
    },

    // 控制
    play() {
      console.log("播放");
    },
    stopPlay() {
      let params = {
        channelId: this.deviceSerial,
        direction: "",
        token: this.accessToken,
      };
      this.$api.customizationStop(params).then((response) => {
        console.log(response);
      });
    },
    CapturePicture() { },
    PtzFocusDowns(index) {
      console.log(index);
      let params = {
        channelId: this.deviceSerial, //通道ID
        direction: index, //操作命令： 0-上，1-下，2-左，3-右，4-左上，5-左下，6-右上，7-右下，8-放大，9-缩小，10-近焦距，11-远焦距，12-启动光圈，13-缩小光圈，14-亮灯，15-雨刷，16-自动
        speed: 1, //当模式mode为0时：云台速度： 0-慢，1-适中，2-快；当模式mode为1时：云台速度：0-7
        mode: this.typeStatus, //模式传空默认是0，mode只有0,1两种状态
        token: this.accessToken, //accessToken
      };
      this.$api.customizationStart(params).then((response) => {
        console.log(response);
      });
    },
    PtzDirection(index) {
      console.log(index);
      let params = {
        channelId: this.deviceSerial, //通道ID
        direction: index, //操作命令： 0-上，1-下，2-左，3-右，4-左上，5-左下，6-右上，7-右下，8-放大，9-缩小，10-近焦距，11-远焦距，12-启动光圈，13-缩小光圈，14-亮灯，15-雨刷，16-自动
        speed: 1, //当模式mode为0时：云台速度： 0-慢，1-适中，2-快；当模式mode为1时：云台速度：0-7
        mode: this.typeStatus, //模式传空默认是0，mode只有0,1两种状态
        token: this.accessToken, //accessToken
      };
      this.$api.customizationStart(params).then((response) => {
        console.log(response);
      });
    },
    PtzDirectionStop(index) {
      console.log(index);
      let params = {
        channelId: this.deviceSerial,
        direction: index,
        token: this.accessToken,
      };
      this.$api.customizationStop(params).then((response) => {
        console.log(response);
      });
    },
    changeType(index) {
      this.typeStatus = index;
    },
  },
};
</script>
<style lang="scss" scoped>
.vedeo-container {
  //   width: 100%;
  //   height: 100%;
  //   padding: 10px;
  display: flex;
  height: calc(100% - 104px);
  padding: 10px;
  margin-top: 8px;

  .list-wrap {
    width: 240px;
    padding: 0 10px;

    .cameraList {
      height: 450px;
      overflow-y: auto;
      overflow-x: hidden;
      box-sizing: border-box;
      padding: 10px 10px;
      color: #afb9cb;
      li {
        list-style-type: none;
        text-align: center;
        height: 36px;
        line-height: 36px;
        background: rgba(100, 149, 237, 0.5);
        background-color: #1a3669;
        margin-bottom: 10px;
        border-radius: 2px;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0 8px;
        text-align: center;
        a {
          color: #afb9cb;
        }
        a:hover {
          color: white;
        }
      }
    }
  }
  .vedio-wrap {
    width: calc(100% - 260px);
    height: calc(100% - 40px);
    background: black;
    margin: 0px 10px 10px 10px;
  }
}
.sskClass {
  margin: 40px auto 20px auto;
}
.guanbi {
  position: absolute;
  right: 30px;
  top: 30px;
}
.body-container {
  width: calc(100% - 260px);
  height: 100%;
  margin-left: 16px;
  background: linear-gradient(
    180deg,
    rgba(10, 51, 71, 0.1),
    rgba(10, 51, 71, 0.4),
    rgba(46, 132, 219, 0.2)
  );
  // background: url("../../assets/image/bg-image/bg-content.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  .child-page-container {
    //   padding: 60px 40px 0px 40px;

    padding: 20px 40px 0px 40px;
    padding-bottom: 10px;
    height: calc(100% - 40px);
    overflow-y: auto;
    overflow-x: hidden;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .child-page-title {
    position: absolute;
    top: 32px;
    left: 50px;
    font-size: 16px;
    // color: rgba(82,154,255,1);

    display: inline-block;
    font-weight: bold;
    letter-spacing: 2px;
    span {
      color: rgb(82, 154, 255);
    }
    .back {
      margin-right: 16px;
      font-size: 15px;
      color: rgba(82, 154, 255, 0.75);
    }
    .title-before {
      &::before {
        content: "";
        width: 9px;
        display: inline-block;
        height: 9px;
        // background: #84ffe9;
        background: #529aff;
        margin-right: 8px;
        border-radius: 1px;
      }
    }
  }
}
.top-splitscreen {
  //   position: absolute;
  float: right;
  margin-top: 10px;
  top: 30px;
  right: 20px;
  .top-splitscreen-select {
    width: 90px;
  }
}
.monitor-content {
  clear: both;
  width: 100%;
  height: calc(100% - 50px);
  padding: 20px;
  display: flex;
  flex-direction: column;
  .content-bottom {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: -10px;
    overflow: hidden;
    .monitor-column {
      flex: 1;
      display: flex;
      overflow: hidden;
      &:not(:last-child) {
        margin-bottom: 5px;
      }
      .monitor-row {
        flex: 1;
        display: flex;
        background: rgba(0, 0, 0, 0.3);
        border-radius: 2px;
        position: relative;
        overflow: hidden;
        border: 1px solid transparent;
        &.active {
          border: 1px solid #529aff;
        }
        &:not(:last-child) {
          margin-right: 5px;
        }
        .iframe-mask {
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 9;
          &:hover {
            .iframe-close,
            .iframe-note {
              opacity: 1;
              transition: opacity 1s;
            }
          }
          .iframe-close {
            opacity: 0;
            transition: opacity 1s;
            position: absolute;
            top: 5px;
            right: 5px;
          }
          .iframe-note {
            opacity: 0;
            transition: opacity 1s;
            position: absolute;
            width: 100%;
            height: 32px;
            bottom: 0;
            padding: 0 8px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: rgba(0, 0, 0, 0.5);
            font-weight: bold;
            .note-name {
              flex: 1;
              display: inline-flex;
              overflow: hidden;
              margin-right: 8px;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .ali-icon {
              color: rgba(255, 255, 255, 0.5);
              &:hover {
                color: #ffffff;
                cursor: pointer;
              }
            }
          }
        }
        .videp-player {
          width: 100%;
          height: 100%;
          border: none;
          border-radius: 2px;
          position: absolute;
          z-index: 1;
        }
        .video-desc {
          width: 100%;
          height: 100%;
          position: absolute;
          .desc-top-left {
            position: absolute;
            top: 15px;
            left: 15px;
            display: inline-flex;
            flex-direction: column;
            label {
              font-size: 12px;
              font-weight: bold;
              color: #ffffff;
              line-height: 14px;
              &:not(:last-child) {
                margin-bottom: 4px;
              }
            }
          }
          .desc-play-button {
            position: absolute;
            top: 50%;
            left: 50%;
            margin: -18px 0 0 -18px;
            font-size: 36px;
            color: rgba(255, 255, 255, 0.56);
            &:hover {
              cursor: pointer;
              color: #ffffff;
            }
          }
          .desc-bottom {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 32px;
            text-align: center;
            line-height: 32px;
            background: rgba(0, 0, 0, 0.7);
            font-size: 14px;
            font-weight: bold;
            color: #ffffff;
          }
        }
      }
    }
  }
}
.page {
  position: absolute;
  top: 0px;
  bottom: 0;
  left: 0;
  right: 0;
}

.content {
  height: 98%;
  min-height: 750px;
}

.content > .box {
  height: 100%;
  min-height: 750px;
}

.content > .box > div {
  background: rgba(5, 12, 39, 0.3);
  box-shadow: 0px 1px 13px 0px rgba(70, 90, 201, 0.48);
  border: 1px solid rgba(85, 143, 255, 0.2);
}

.screen-wrap {
  position: absolute;
  top: -30px;
  right: 44px;
  display: flex;
  justify-content: center;
}

.screen-wrap li {
  padding-right: 20px;
  cursor: pointer;
}

.content .menu-wrap {
  width: 260px;
  padding-bottom: 30px;
  /* margin-right: 20px */
}

.content .menu-wrap > p {
  margin: 30px 0 10px 30px;
  font-size: 16px;
}

.content .menu-wrap > p img {
  vertical-align: middle;
  width: 24px;
}

.content .menu-wrap > #movieLsit > .item > p {
  padding: 10px 0;
  padding-left: 50px;
  cursor: pointer;
}

.content .menu-wrap > div > p img {
  vertical-align: middle;
  margin-right: 4px;
}

.content .menu-wrap li {
  color: #9193bf;
  cursor: pointer;
  border-left: 3px solid #162579;
}

.content .menu-wrap li span {
  display: inline-block;
  padding: 14px 0 14px 70px;
  font-size: 15px;
}

.li_active {
  background: rgb(12, 27, 109);
  color: #38e9ec !important;
  border-left: 3px solid #38e9ec !important;
}

.vedio-wrap {
  width: calc(100% - 300px);
}

.vedio-wrap .box {
  justify-content: flex-start;
  flex-flow: row wrap;
  height: 100%;
}

.video-list {
  width: calc(100% - 220px);
  padding: 10px;
}

.video-control {
  width: 100%;
  height: calc(100% - 100px);
  position: relative;
}

.video-control img {
  cursor: pointer;
  padding: 1px;
}

.control-c {
  position: absolute;
  top: 250px;
  right: 20px;
  left: 20px;
  color: white;
  margin: 0 auto;
}

.control-c img {
  width: 22px;
  padding: 5px 5px 4px 5px;
  background: rgba(18, 20, 101, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 2px;
}

.control-c img:hover {
  box-shadow: 0px 1px 13px 0px rgba(70, 90, 201, 0.48);
}

.control-c img:active {
  background: rgb(44, 46, 156);
}

.control-c .box {
  margin-bottom: 18px;
}

.control-c .box > div {
  flex: 1;
}

.control-c .text-right {
  text-align: right;
}

.control-c .text-center {
  text-align: center;
}

.control-d {
  position: absolute;
  top: 40px;
  right: 10px;
  left: 10px;
  background: #121465;
  height: 180px;
  width: 180px;
  border-radius: 100%;
  z-index: 2;
  margin: 0 auto;
}

.control-d img {
  padding: 2px;
}

.control-d img:hover {
  box-shadow: 0px 1px 13px 0px rgba(70, 90, 201, 0.48);
}

.control-d img:active {
  background: rgb(44, 46, 156);
}

.control-d > div {
  height: 100%;
  width: 100%;
  position: relative;
}

.contrl_back {
  position: absolute;
  top: 42px;
  left: 42px;
  right: 42px;
  bottom: 42px;
  opacity: 0.2;
  z-index: 1;
}

.contrl_back img {
  width: 100%;
}

.control-d .up {
  position: absolute;
  top: 10px;
  left: 80px;
  z-index: 4;
}

.control-d .down {
  position: absolute;
  bottom: 10px;
  left: 80px;
  z-index: 4;
}

.control-d .left {
  position: absolute;
  top: 81px;
  left: 10px;
  z-index: 4;
}

.control-d .right {
  position: absolute;
  top: 81px;
  right: 10px;
  z-index: 4;
}

.control-p {
  position: absolute;
  top: 420px;
  right: 10px;
  left: 10px;
  z-index: 2;
  margin: 0 auto;
}

.control-p .box > div {
  flex: 1;
}

.control-p .box > div li {
  text-align: center;
  width: 80%;
  margin-left: 10%;
  cursor: pointer;
  padding: 8px 0;
  background: rgba(18, 20, 101, 0.5);
  margin-bottom: 20px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 4px;
}

.control-p .box > div li:hover {
  box-shadow: 0px 1px 13px 0px rgba(70, 90, 201, 0.48);
}

.control-p .box > div li:hover p {
  color: #ffffff;
}

.control-p .box > div li:active {
  background: rgb(44, 46, 156);
}

.control-p .box p {
  color: #a8a8e2;
}

.stream-type li {
  font-size: 12px;
  color: #a8a8e2;
}

.control_active span {
  color: #00fff9;
}

.content .menu-wrap .itemWord img {
  vertical-align: middle;
  margin-right: 4px;
}

.content .menu-wrap li {
  color: #9193bf;
  cursor: pointer;
  border-left: 3px solid #162579;
}

.content .menu-wrap li span {
  display: inline-block;
  padding: 14px 0 14px 70px;
}

.itemWord {
  position: relative;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(255, 255, 255, 0.1);
}

.itemWord:hover ul {
  display: block;
  box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.28);
}

.chooseItem {
  display: inline-block;
  margin-left: 10px;
  padding: 12px;
  color: #ffffff;
  font-size: 16px;
}

.itemWord ul {
  position: absolute;
  left: 0;
  top: 45px;
  background-color: #1e2f89;
  width: 100%;
  display: none;
}

.itemWord ul li {
  height: 40px;
  line-height: 40px;
  padding: 0 18px;
  font-size: 15px;
  color: #efefef;
}

.itemWord ul li:hover {
  color: #00fff9;
}

.item {
  color: #9193bf;
}
.box {
  display: flex;
  align-items: center;
  li {
    list-style-type: none;
  }
}
</style>
<style>
.sskClass .ant-input {
  border-radius: 20px;
}
</style>